export default __webpack_public_path__ + "static/Bunker_Customs_banner-5e878ddfafb1ba9f4df9977d13153130.jpg";